import { render, staticRenderFns } from "./AppBlog.vue?vue&type=template&id=aa057e3e&scoped=true"
import script from "./AppBlog.vue?vue&type=script&lang=js"
export * from "./AppBlog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa057e3e",
  null
  
)

export default component.exports